import React from 'react';
import { API } from 'common';
import Page from 'components/Page';
import { toastRef } from 'components/Toast';
import _, { first, sumBy } from 'lodash';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import DollarInput from './maskedInput';
import './SelectTipScreen.css';
import TipOptionsSelector from './TipOptionsSelector';

const SelectTipScreen = () => {
  const { ticketId } = useParams();
  const history = useHistory();
  const [totalAmount, setTotalAmount] = useState(0);
  const [cardFee, setCardFee] = useState(0);
  const [staffMembers, setStaffMembers] = useState([]);
  const [tipValue, setTipValue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  // Fetch ticket data on component mount
  const fetchPayment = async () => {
    setIsLoading(true);
    try {
      const res = await API.get(`/report/getBillDetailV2?billId=${ticketId}`);
      const detail = res.data.payload;
      if (detail) {
        setTotalAmount(detail.total);
        setCardFee(detail.cashDiscountCredit);
        const staff = _.chain(detail?.services || [])
          .groupBy("staffId")?.map((services, key) => {
            const o = first(services);
            return ({
              staffId: key,
              id: o.staffId,
              name: o.technician,
              avatar: '',
              services: services.map(ser => {
                return ({
                  name: ser?.serviceName, price: o.price,
                });
              })
            })
          }).value();
        setStaffMembers(staff.map(o => ({
          id: o.staffId, name: o.name, serviceAmount: sumBy(o.services, s => s.price), tipAmount: 0
        })));
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchPayment();
  }, [ticketId]);

  // Handle continue button click
  const handleContinue = () => {
    if (staffMembers.length > 1) {
      // If there are multiple staff members, go to split view
      history.replace(`/ticketDetailV2/${ticketId}/split-tip?amount=${tipValue}`);
    } else {
      // Otherwise, save and go back
      handleSaveTip();
    }
  };

  // Handle saving tip for a single staff
  const handleSaveTip = async () => {
    try {
      setIsLoading(true);
      const res = await API.put('bill/updateTipStaff', {
        payload: {
          billId: ticketId,
          totalTip: tipValue,
          data: [{
            staffId: first(staffMembers)?.id || "",
            tipAmount: tipValue
          }]
        }
      });
      if (res.data.payload) {
        if (toastRef.current) toastRef.current.success('Success');
        history.replace(`/ticketDetailV2/${ticketId}`);
      }
    } catch (error) {
      console.error('Error saving tip:', error);
    } finally {
      setIsLoading(false);
    }
  };
  const StickFooter = () => {
    return (
      <div className='select-tip-footer bg-white px-3'>
        <button disabled={isLoading} className='select-tip-continue' onClick={handleContinue}>
          {staffMembers?.length > 1 ? 'Continue' : 'Done'}
        </button>
      </div>
    )
  };
  return (
    <Page loading={isLoading} title='Add Tip' className='pb-0' StickFooter={StickFooter}>
      <div className='select-tip-container'>
        <div className='select-tip-content'>
          <div className='bg-white p-3'>
            <p className='select-tip-prompt'>Would you like to leave a tip?</p>
            <p className='select-tip-amount'>${totalAmount.toFixed(2)}</p>
            <p className='select-tip-card-fee'>CARD FEE: {cardFee}%</p>

            <TipOptionsSelector
              totalAmount={totalAmount}
              setTipValue={setTipValue}
              tipValue={tipValue}
            />

            <div className='select-tip-custom'>
              <p>Custom Tip</p>
              <DollarInput
                value={tipValue}
                withForm
                onChange={setTipValue}
              />
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default SelectTipScreen;
